// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categories-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 16px;
    padding-bottom: 80px;
    padding-top: 20px;
  }
  
  .category-card {
    background-color: black;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid white;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  
  .category-card.dragging {
    transform: scale(1.05);
    box-shadow: 0 8px 16px white;
  }
  
  .category-title {
    font-size: 1.2em;
    font-weight: bold;
    color: white;
  }
  
  .reorder-buttons {
    display: flex;
    gap: 8px;
  }
  
  .reorder-buttons button {
    font-size: 1rem;
    padding: 8px 12px;
    border: 1 px solid white;
    border-radius: 4px;
    background-color: black;
    color: white;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .reorder-buttons button:disabled {
    background-color: black;
    color: black;
    cursor: not-allowed;
  }
  
  .reorder-buttons button:hover:not(:disabled) {
    background-color: gray;
  }
  `, "",{"version":3,"sources":["webpack://./src/private/Admin/CategoryOrder.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qDAAqD;EACvD;;EAEA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB","sourcesContent":[".categories-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    padding: 16px;\r\n    padding-bottom: 80px;\r\n    padding-top: 20px;\r\n  }\r\n  \r\n  .category-card {\r\n    background-color: black;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    border: 1px solid white;\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n  }\r\n  \r\n  .category-card.dragging {\r\n    transform: scale(1.05);\r\n    box-shadow: 0 8px 16px white;\r\n  }\r\n  \r\n  .category-title {\r\n    font-size: 1.2em;\r\n    font-weight: bold;\r\n    color: white;\r\n  }\r\n  \r\n  .reorder-buttons {\r\n    display: flex;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .reorder-buttons button {\r\n    font-size: 1rem;\r\n    padding: 8px 12px;\r\n    border: 1 px solid white;\r\n    border-radius: 4px;\r\n    background-color: black;\r\n    color: white;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n  }\r\n  \r\n  .reorder-buttons button:disabled {\r\n    background-color: black;\r\n    color: black;\r\n    cursor: not-allowed;\r\n  }\r\n  \r\n  .reorder-buttons button:hover:not(:disabled) {\r\n    background-color: gray;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
